export default {
  title: 'Kontakt',
  sections: {
    contact_hero_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="highlight">Kontakt</div>Engineering the future together',
            text2: 'Fordern Sie uns mit Ihrem persönlichen Anliegen heraus und lernen Sie uns in einem unverbindlichen Gespräch kennen',
            image: '/seu/latest-assets/seu_28.jpg',
          }
        },
      }
    },
    contact_contact_section: {
      fields: {
        field_one: {
          value: {
            title: 'Was ist Ihre aktuelle Herausforderung?',
            subTitle: 'Wir freuen uns auf Ihre Kontaktaufnahme und sichern <br/>Ihnen höchste Diskretion und Vertraulichkeit zu.',
            buttonLabel: 'Rufen Sie uns an',
            buttonLabel2: 'Schreiben Sie uns',
            image: '/seu/latest-assets/seu_36.jpg',
            link1: 'tel:+41 (0)58 521 19 00',
            link2: 'mailto:verwaltungsrat@seu.ch'
          }
        },
      }
    },
    contact_divider_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Kontakt'
          }
        }
      }
    },
    contact_text_section: {
      fields: {
        field_one: {
          value: {
            text: '<span class="text-highlight">Reservieren Sie einen Gesprächs-<br/>termin</span>',
            text2: 'Mehrere Köpfe denken weiter als einer allein. Lassen Sie uns gemeinsam Lösungen finden.'
          }
        },
        field_three: {
          value: {
            text: 'Wir bieten Antworten. Praxisnah und fundiert, schnell und weitsichtig.',
            text2: 'Sie planen Grosses und wünschen sich einen zuverlässigen Partner? Sie suchen eine Nachfolge und wissen nicht, wie Sie vorgehen sollen?',
            buttonLabel: 'Jetzt online buchen',
            buttonIconLeft: '/seu/arrow-right.svg'
          }
        },
      }
    },
    contact_info_section: {
      fields: {
        field_one: {
          value: {
            title: 'NEHMEN SIE KONTAKT AUF',
            text: 'Wir freuen uns darauf, von Ihnen zu hören und gemeinsam herauszufinden, wie wir Ihnen bei der Zukunftsentwicklung Ihres Ingenieurunternehmens behilflich sein können.<br> <br> Hier finden Sie unsere Kontaktinformationen sowie eine detaillierte Anfahrtsbeschreibung, die Ihnen bei der Planung Ihres Besuchs behilflich sein wird.',
            location: 'Churerstrasse 54 CH-8808 Pfäffikon SZ',
            number: '+41 (0)58 521 19 00',
            website: 'www.seu.ch',
            email: 'info@seu.ch',
            linkedin: 'LinkedIn',
            icon1: '/seu/latest-icons/contact/location-black.svg',
            icon2: '/seu/latest-icons/contact/phone-black.svg',
            icon3: '/seu/latest-icons/contact/website-black.svg',
            icon4: '/seu/latest-icons/contact/mail-black.svg',
            icon5: '/seu/latest-icons/contact/linkedin-black.svg',
            buttonIcon: '/seu/location-white.svg',
            buttonLabel: 'AUF GOOGLE MAPS ANZEIGEN',
            buttonIcon2: '/seu/direction.svg',
            buttonLabel2: 'ANFAHRT',

          }
        },
      }
    },
    contact_divider2_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Kontakt'
          }
        }
      }
    },
    contact_text_2_section: {
      fields: {
        field_one: {
          value: {
            text: '<span class="text-highlight">Firmen- präsentation</span>',
            text2: 'Auf Augenhöhe kommen'
          }
        },
        field_three: {
          value: {
            text: 'Bevor Sie mit uns Kontakt aufnehmen und uns persönlich kennen lernen, möchten Sie gerne mehr Informationen über uns erhalten.',
            text2: 'Sehr gerne. Wir wissen, welche Fragen Sie beschäftigen und haben unsere Antworten für Sie zusammengestellt. <span class="text-highlight"> Laden Sie hier unsere Kurzpräsentation herunter. </span>',
            buttonLabel: 'Download pdf',
            buttonIconLeft: '/seu/arrow-right.svg'
          }
        },
      }
    },
  }
}
